import { useClientFeedApiEndpoint } from '~/hooks/use-client-feed-api-endpoint';
import { useCacheFetch } from '~/hooks/use-cache-fetch';
import type { Props } from './client-ui-component.client';

export function ClientUiComponentCacheFetch({
  Component,
  uiComponent,
  storageFeedsData,
  isLoggedInData,
}: Props): JSX.Element {
  const uiComponentDataSource: string | undefined = uiComponent?.data?.source;

  const { clientFeedApiEndpoint } = useClientFeedApiEndpoint({
    uiComponent,
  });

  const { jsonData, isLoading } = useCacheFetch({
    url: !uiComponentDataSource ? null : clientFeedApiEndpoint,
  });

  return (
    <Component
      isClient={true}
      isLoading={isLoading}
      uiComponent={uiComponent}
      feed={jsonData}
      storageFeedsData={storageFeedsData}
      isLoggedInData={isLoggedInData}
    />
  );
}
